export const adaptComboRI = (combo) => {
    return {
        id: combo?.idComboRIValor,
        displayName: combo?.valor,
    }
}

export const adaptCombosRIArray = (combos) => {
    return (
        Object.fromEntries(
            Object.entries(combos).map(
                ([key, value]) => {
                    return [key, value.comboRIValor.map(comboValor => adaptComboRI(comboValor))]
                }
            )
        )
    )
}